import React, { FC } from 'react';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Upload } from 'antd';
import { RcFile } from 'antd/es/upload';
import styles from './styles.module.less';

interface Props {
  onChange: (file: RcFile) => void,
  fileName: string | null,
  isLoading: boolean,
}

const Uploader: FC<Props> = ({
  onChange,
  fileName,
  isLoading,
}) => (
  <Upload
    name="file"
    listType="text"
    beforeUpload={(file) => {
      onChange(file);
      return false;
    }}
    fileList={
      fileName
        ? [{
          uid: '1',
          name: fileName,
          status: 'done',
          url: '',
        }]
        : []
    }
    multiple={false}
    showUploadList={{
      showPreviewIcon: false,
      showDownloadIcon: false,
      removeIcon: false,
      downloadIcon: null,
      previewIcon: null,
      showRemoveIcon: false,
    }}
    accept=".csv"
    maxCount={1}
    style={{ display: 'flex', flexDirection: 'row' }}
  >
    <div className={styles.uploadButton}>
      <div>
        {
        isLoading
          ? <LoadingOutlined className={styles.planUploadCompleteModal} />
          : <PlusOutlined className={styles.planUploadCompleteModal} />
        }
        <div style={{ marginTop: 8 }}>Click or Drop a CSV to Upload</div>
      </div>
    </div>
  </Upload>
);

export default Uploader;
